import { render, staticRenderFns } from "./PointLabel.vue?vue&type=template&id=bdbf9924&"
import script from "./PointLabel.vue?vue&type=script&lang=js&"
export * from "./PointLabel.vue?vue&type=script&lang=js&"
import style0 from "./PointLabel.vue?vue&type=style&index=0&id=bdbf9924&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports